import { CloudCustomerAddress } from "@omni/types/api/customer/cloud/address.model";
import { AddressType } from "@omni/types/api/customer/cloud/shared/enums/addressType.enum";
import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";
import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";
import { cn } from "@omni/utils/styles";

import { AddressContainer } from "@/components/Address/Address/address.container";
import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { getDeliveryAddress, getPaymentAddress } from "@/utils/address/address";

type Props = {
    customer: ComponentsCustomer | null;
    addresses: Array<CloudCustomerAddress>;
    link: string;
};

const ProfileAddresses = ({ customer, addresses, link }: Props) => {
    const { t } = useGranite();
    const paymentAddress = getPaymentAddress(addresses);
    const deliveryAddress = getDeliveryAddress(addresses);

    const isSameAddress = paymentAddress?.id === deliveryAddress?.id;

    return (
        <div>
            {addresses.length === 0 && (
                <Row className={cn("tw:mt-4")}>
                    <Col>
                        <p> {t("profileAddresses.addressBook.empty")}</p>
                    </Col>
                </Row>
            )}
            {addresses.length > 0 && (
                <Row>
                    {paymentAddress && (
                        <Col
                            xs={12}
                            sm={6}
                            md={4}
                            className={cn("tw:mb-4 tw:sm:mb-0")}
                        >
                            <h4>
                                <p>
                                    {t(
                                        isSameAddress
                                            ? "profileAddresses.title.paymentAndDelivery"
                                            : "profileAddresses.title.paymentAddress"
                                    )}
                                </p>
                            </h4>
                            <div>
                                {customer?.customerType ===
                                    ComponentsCustomerType.B2B && (
                                    <div>
                                        <div>{customer?.companyName}</div>
                                        <div>
                                            {`${customer?.vatNrPrefix}${customer?.vatNr}`}
                                        </div>
                                    </div>
                                )}
                                <AddressContainer
                                    address={paymentAddress}
                                    addressType={AddressType.Payment}
                                />
                            </div>
                        </Col>
                    )}
                    {deliveryAddress && !isSameAddress && (
                        <Col
                            xs={12}
                            sm={6}
                            md={4}
                        >
                            <h4>
                                <p>
                                    {t(
                                        "profileAddresses.title.deliveryAddress"
                                    )}
                                </p>
                            </h4>
                            <div>
                                <AddressContainer
                                    address={deliveryAddress}
                                    addressType={AddressType.Delivery}
                                />
                            </div>
                        </Col>
                    )}
                </Row>
            )}
            <Row className={cn("tw:mt-4")}>
                <Col>
                    <a href={link}>
                        <i className={cn("las la-pencil-alt", "tw:mr-2")} />
                        {t("profileAddresses.link.changeAddresses")}
                    </a>
                </Col>
            </Row>
        </div>
    );
};

export default ProfileAddresses;
